var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gs-app gm-studio",staticStyle:{"min-height":"0","padding-bottom":"0"}},[_c('forms-nav'),_c('p',{staticClass:"gm-muted"},[_vm._v(" Your existing forms are here. They keep their current links, integrations and editor. ")])],1),_c('legacy-forms')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }